var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.ready
    ? _c(
        "w-container",
        [
          _c(
            "w-row",
            { staticClass: "grow", attrs: { center: "" } },
            [
              _c(
                "w-col",
                { attrs: { center: "" } },
                [_c("w-progress-circular")],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm.currentTab == 0
    ? _c("app-company-edit", {
        model: {
          value: _vm.company,
          callback: function ($$v) {
            _vm.company = $$v
          },
          expression: "company",
        },
      })
    : _vm.currentTab == 1
    ? _c("app-company-edit-users", {
        model: {
          value: _vm.company,
          callback: function ($$v) {
            _vm.company = $$v
          },
          expression: "company",
        },
      })
    : _vm.currentTab == 2
    ? _c("app-company-edit-dossiers", {
        model: {
          value: _vm.company,
          callback: function ($$v) {
            _vm.company = $$v
          },
          expression: "company",
        },
      })
    : _vm.currentTab == 3
    ? _c("app-company-edit-modules", {
        model: {
          value: _vm.company,
          callback: function ($$v) {
            _vm.company = $$v
          },
          expression: "company",
        },
      })
    : _vm.currentTab == 4
    ? _c("app-company-invoices", { attrs: { company: _vm.company } })
    : _vm.currentTab == 5
    ? _c("app-company-subscriptions", { attrs: { company: _vm.company } })
    : _vm.currentTab == 6
    ? _c("app-company-edit-crm", { attrs: { company: _vm.company } })
    : _vm.currentTab == 7
    ? _c("app-company-billing", { attrs: { company: _vm.company } })
    : _vm.currentTab == 8
    ? _c("app-company-edit-emails", { attrs: { company: _vm.company } })
    : _vm.currentTab == 9
    ? _c("app-company-ctep-terminals", {
        model: {
          value: _vm.company,
          callback: function ($$v) {
            _vm.company = $$v
          },
          expression: "company",
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }